import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema, useFetch } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";

/*
 * Survey Participate Service
 * !== 설문 참여 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/mypage/surv`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/mypage/surv`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0305001q: `${BASE.path}/ptli0305001q`, // Survey Participate !== 설문 참여 ==!
    ptli0305002q: `${BASE.path}/ptli0305002q`, // Survey Participate !== 설문 참여 ==!
};

const code = [
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
];

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // 현재 진행중인 설문조사 불러오기
    getSurvPrtcpntList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getSurvDtl: (qestnrId: string) => api.get(`${BASE.api}/${qestnrId}`),

    saveSurvRspn: (data: any) => {
        return api.post(`${BASE.api}/${data.qestnrId}/participate`, data);
    },
};

export const SF_SURV_PRTCPNT_LIST_SRCH: TFormSchema = {
    id: "form_SurvSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
    },
};

export const SF_SURV_INFO: TFormSchema = {
    id: "form_survInfo",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        mnPgeQustnrYn: {
            type: "radio",
            label: "L_MN_PGE_QUSTNR_YN",
            required: true,
            options: [
                { label: "Main Page Question", value: "Y" },
                { label: "Sub Page Question", value: "N" },
            ],
        },
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        qustnrPupsCn: { type: "text", label: "L_QUSTNR_PUPS_CN" },
        qustnrMakeInfoCn: { type: "text", label: "L_QUSTNR_MAKE_INFO_CN" },
        qustnrTrgtAcrdtYn: {
            type: "radio",
            label: "L_QUSTNR_TRGT_ACRDT_YN",
             area: "comnCd",
             comnCd: "PTL0063",
            // options: [
            //     { label: "User", value: "1" },
            //     { label: "non-User", value: "2" },
            // ],
            defaultValue: "1",
            required: true,
        },  // comnCd 생성 필요 (회원 / 비회원)
        reqDateRnge: {
            type: "datetime",
            label: "L_RQST_DT",
            start: { name: "qustnrStrtDt" },
            end: { name: "qustnrEndDt" },
            rangeButton: 4,
        },
    },
};

export const SF_SURV_PRTCPNT_HEAD: TFormSchema = {
    id: "form_SurvHead",
    schema: {
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        qustnrPupsCn: { type: "textarea", label: "L_QUSTNR_PUPS_CN", rows: 3 },
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "qustnrStrtDt" },
            end: { name: "qustnrEndDt" },
        },
        qustnrStrtDt: { type: "datetime", label: "L_QUSTNR_STRT_DT" },
        qustnrEndDt: { type: "datetime", label: "L_QUSTNR_END_DT" },
    },
};

export const SF_SURV_PRTCPNT_QUESTION: TFormSchema = {
    id: "form_SurvQues",
    schema: {
        quesCn: { type: "text", label: "L_QUES_CN" },
        quesTpCd: { type: "text", label: "L_QUES_TP_CD" },
        itmCn: {
            type: "radio",
            label: "L_ITM_CN",
            options: [
                { label: "itmCn1", value: "itmCn1" },
                { label: "itmCn2", value: "itmCn2" },
            ],
        },
        itemText: {
            type: "text",
            label: "L_ITM_CN",
        },
    },
};

export const SF_SURV_PRTCPNT_ITEM: TFormSchema = {
    id: "form_SurvItm",
    schema: {
        ItmCn: { type: "text", label: "L_QUES_CN" },
    },
};

export const SF_SURV_USR_INFO: TFormSchema = {
    id: "form_SurvUsrInfo",
    schema: {
        usrNm: { type: "text", label: "L_USR_NM" },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        cstmSctnOrgzCd: { type: "code", label: "L_CSTM_SCTN", area: "cstmOrgzCd" },
        usrTin : { type: "text", label: "L_USR_TIN" },
        cstmUnitOrgzCd: { type: "code", label: "L_CSTM_UNIT", area: "cstmOrgzCd" },
        roleNm: { type: "code", label: "L_ROLE_ID", area: "roleCd" },
        sysmUseFreqCd: {
            type: "radio",
            label: "L_SYSM_USE_FREQ_CD",
            area: "comnCd",
            comnCd: "PTL0059",
            controlSize: 10,
        },
        ptlTpCd: {
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        cstmOfcrNo: {
            type: "text",
            label: "L_CSTM_OFCR_NO",
        },
    },
};

export const SF_SURV_PRTCPNT_QUESTION_LIST: TFormSchema = {
    id: "form_SurvQuesList",
    schema: {
        questions: {
            type: "array",
            schema: {
                quesCn: { type: "text", label: "L_QUES_CN", readOnly: true, edit: false },
                quesTpCd: { type: "text", label: "L_QUES_TP_CD" },
                itmCn: {
                    type: "radio",
                    label: "L_ITM_CN",
                    options: [],
                },

                itemText: { type: "text", label: "L_ITM_CN" },
            },
        },
    },
};

export const SG_SURV_PRTCPNT_LIST: TGridSchema = {
    id: "grid_SurvPrtcpntList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "*" }] ,id: "bsopClsfCd" },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCdNm", width: "*" }] ,id: "ptlTpCd" },
        { cells: [{ header: "L_QUSTNR_TTLE", binding: "qustnrTtle", width: "*" }] },
        { cells: [{ header: "L_QUSTNR_PUPS_CN", binding: "qustnrPupsCn", width: "35%" }] },
        { cells: [{ header: "L_QUSTNR_STRT_DT", binding: "qustnrStrtDt", width: "12%" }] },
        { cells: [{ header: "L_QUSTNR_END_DT", binding: "qustnrEndDt", width: "12%" }] },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", align: "center" }] },
        { cells: [{ binding: "ptlTpCdNm", align: "center" }] },
        { cells: [{ binding: "qustnrTtle", align: "left" }] },
        { cells: [{ binding: "qustnrPupsCn", align: "left" }] },
        { cells: [{ binding: "qustnrStrtDt", type: "datetime" }] },
        { cells: [{ binding: "qustnrEndDt", type: "datetime" }] },
    ],
};
